import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

// Understated secondary invitation — recruiting is a secondary journey and
// should never compete with the primary client experience.
export const CareersInvite = () => {
  return (
    <section data-testid="careers-invite" className="relative bg-[#030303] border-t border-white/10 py-16 lg:py-20">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 border border-white/10 rounded-sm px-8 py-10 lg:px-12 lg:py-12 bg-[#0a0a0a]">
            <div className="max-w-2xl">
              <span className="mono text-[10px] uppercase tracking-[0.35em] text-[#737373] block mb-4">Careers at JCI</span>
              <h2 className="serif font-light text-[#f4f0ea] text-2xl md:text-3xl leading-snug mb-3">
                Interested in helping families while building your own <span className="italic text-[#d4af37]">agency</span>?
              </h2>
              <p className="text-[#a3a3a3] text-base leading-relaxed tracking-wide">
                Learn how John Campbell Insurance mentors independent agents who want to build a meaningful
                agency serving families with integrity.
              </p>
            </div>
            <Link
              to="/join"
              data-testid="careers-invite-cta"
              className="group shrink-0 inline-flex items-center gap-3 mono text-xs uppercase tracking-[0.2em] px-8 py-4 border border-[#d4af37]/45 text-[#d4af37] rounded-full hover:bg-[#d4af37] hover:text-[#030303] transition-colors duration-400"
            >
              Explore Careers
              <ArrowRight size={15} className="transition-transform duration-400 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
